// import type { HTMLChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
// import type { HTMLMotionProps } from 'framer-motion';
import { motion } from 'framer-motion';

// type MotionBoxProps = Merge<HTMLChakraProps<'div'>, HTMLMotionProps<'div'>>;

const MotionBox: React.FC<TODO> = motion(chakra.div);

export default MotionBox;

export const HoveringBox = ({
  children,
  width = { base: '50%', sm: '50%', md: '40%', lg: '30%' },
}: TODO) => (
  <MotionBox
    animate={{ y: 20 }}
    transition={{ repeat: Infinity, duration: 2, repeatType: 'reverse' }}
    width={width}
    margin="0 auto"
  >
    {children}
  </MotionBox>
);
